import { transformCurrencyAmountDto } from './currency-amount';
export const transformCurrencyConversionDto = _ref => {
  let {
    seller_currency,
    seller_price,
    seller_shipping_price,
    fx_base_amount,
    fx_rounded_rate,
    fx_markup_rate,
    buyer_currency
  } = _ref;
  return {
    sellerPrice: seller_price,
    sellerShippingPrice: seller_shipping_price,
    sellerCurrency: seller_currency,
    buyerCurrency: buyer_currency,
    fxRoundedRate: fx_rounded_rate,
    fxBaseAmount: fx_base_amount,
    fxMarkupRate: fx_markup_rate
  };
};
export const transformCurrencyConversionWithMoneyObjectDto = _ref2 => {
  let {
    seller_price,
    shipping_price,
    fx_base_amount,
    fx_rounded_rate,
    fx_markup_rate,
    buyer_currency
  } = _ref2;
  return {
    sellerPrice: transformCurrencyAmountDto(seller_price),
    sellerShippingPrice: shipping_price ? transformCurrencyAmountDto(shipping_price) : null,
    buyerCurrency: buyer_currency,
    fxRoundedRate: fx_rounded_rate,
    fxBaseAmount: fx_base_amount,
    fxMarkupRate: fx_markup_rate
  };
};